<template>
  <b-container class="user-view">
    <b-row v-if="login">
      <b-col cols="12" md="3">
        <div class="user-header">
          <img v-if="user.avatar" :src="getImgUrl(user.avatar)" alt />
          <a-avatar v-else :size="64" icon="user" />
          <h5>{{ user.nickname ? user.nickname : "未登录" }}</h5>
          <p v-if="user.mobile">{{ user.mobile }}</p>
        </div>
        <div class="user-list">
          <ul>
            <li
              :class="[active == index ? 'active' : '']"
              v-for="(item, index) in userList"
              :key="index"
              @click="userClick(item, index)"
            >
              <img :src="item.img" />
              <p>{{ item.name }}</p>
            </li>
          </ul>
        </div>
      </b-col>
      <b-col cols="12" md="9" class="user-content">
        <div class="content">
          <router-view></router-view>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import publicChange from "@/assets/js/index.js";
import Api from "@/apis";
export default {
  data() {
    return {
      active: -1,
      userList: [
        {
          img: require("@/assets/img/new/user/6.png"),
          icon: require("@/assets/img/new/user/6.png"),
          unicon: require("@/assets/img/new/user/12.png"),
          name: "账户设置",
          to: "/user/setting"
        },
        {
          img: require("@/assets/img/new/user/1.png"),
          icon: require("@/assets/img/new/user/1.png"),
          unicon: require("@/assets/img/new/user/7.png"),
          name: "人才信息",
          to: "/user/talent"
        },
        {
          img: require("@/assets/img/new/user/2.png"),
          icon: require("@/assets/img/new/user/2.png"),
          unicon: require("@/assets/img/new/user/8.png"),
          name: "我的项目",
          to: "/user/project"
        },
        {
          img: require("@/assets/img/new/user/3.png"),
          icon: require("@/assets/img/new/user/3.png"),
          unicon: require("@/assets/img/new/user/9.png"),
          name: "我的收藏",
          to: "/user/collection"
        },
        {
          img: require("@/assets/img/new/user/4.png"),
          icon: require("@/assets/img/new/user/4.png"),
          unicon: require("@/assets/img/new/user/10.png"),
          name: "我的评论",
          to: "/user/comments"
        },
        {
          img: require("@/assets/img/new/user/5.png"),
          icon: require("@/assets/img/new/user/5.png"),
          unicon: require("@/assets/img/new/user/11.png"),
          name: "我的消息",
          to: "/user/message"
        }
      ],
      user: {},
      login: false
    };
  },
  mounted() {
    this.watchTab();
    this.getUser();
  },
  watch: {
    $route: "watchTab"
  },
  methods: {
    userClick(item, index) {
      publicChange.toRouters(this, item.to);
      this.active = index;
      this.userList.map((items, indexs) => {
        if (indexs === index) {
          items.img = items.unicon;
        } else {
          items.img = items.icon;
        }
      });
    },
    watchTab() {
      const routers = this.$route.path;
      this.userList.map((item, index) => {
        if (routers.indexOf(item.to) > -1) {
          this.active = index;
          item.img = item.unicon;
        } else {
          item.img = item.icon;
        }
      });
    },
    //获取用户详细信息
    async getUser() {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        if (token && token.accessToken) {
          const data = await Api.User.getUserDetail();
          if (data) {
            this.user = data;
            this.login = true;
          }
        }
      } catch (e) {
        this.$router.push({
          path: "/login",
          query: { redirect: location.href }
        });
        this.$message.error("登录过期，请重新登录");
        this.login = false;
        this.user = {};
      }
    },
    onDesc(text) {
      return publicChange.disposeHtml(text);
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    getDate(time) {
      return publicChange.getDate(time);
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    }
  }
};
</script>
<style scoped>
.user-view {
  margin-top: 60px;
  margin-bottom: 100px;
  padding: 0px;
}
.user-header {
  padding: 76px 0px;
  background: #fff;
  margin-bottom: 20px;
}
.user-header img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 11px;
}
.user-header h5 {
  font-size: 26px;
  font-weight: 400;
  color: #333333;
  line-height: 39px;
}
.user-header p {
  font-size: 16px;
  font-weight: 300;
  color: #666666;
  line-height: 24px;
}

.user-list li {
  display: flex;
  align-items: center;
  padding: 35px 31px;
  background: #fff;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;
}
.user-list p {
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  margin-left: 21px;
}
.user-list li img {
  width: 24px;
  height: 24px;
}
.user-list .active {
  background: #3382ff;
}
.user-list .active p {
  color: #fff;
}
.user-content {
  padding-left: 40px;
}
.user-content .content {
  background: #fff;
  height: auto;
  padding: 34px 0px;
}
</style>
